"use client"

import { useState, type ComponentProps } from "react"

import { AppDialog } from "./app-dialog"

type CustomProps = Extract<ComponentProps<typeof AppDialog>, { variant: "custom" }>

/** Public adapter for inventoried intentional layouts. Ordinary dialogs use the named standard components. */
export function CustomDialog({
  open: controlledOpen,
  onOpenChange,
  defaultOpen = false,
  ...props
}: Omit<CustomProps, "variant" | "open" | "onOpenChange"> & {
  open?: boolean
  onOpenChange?: (open: boolean) => void
  defaultOpen?: boolean
}) {
  const [localOpen, setLocalOpen] = useState(defaultOpen)
  return (
    <AppDialog
      {...props}
      variant="custom"
      scrollable={props.scrollable ?? props.contentProps?.scrollable ?? undefined}
      open={controlledOpen ?? localOpen}
      onOpenChange={(open) => {
        setLocalOpen(open)
        onOpenChange?.(open)
      }}
    />
  )
}
